import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Componentes
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Páginas
import Home from './pages/Home';
import ChatAdmin from './pages/ChatAdmin';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname === '/chat-admin';

  return (
    <>
      {!isAdminRoute && <Navbar />}

      <Routes>
        <Route path="/chat-admin" element={<ChatAdmin />} />
        <Route path="/" element={<Home />} />
      </Routes>

      {!isAdminRoute && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
